<!--  -->
<template>
  <div>
    <div class="channelnumber">
      <div style="margin-bottom:20px">
        <span style="margin-right:25px">平台</span>
        <el-select v-model="obj.platform_id" style="margin-right:20px" placeholder="请选择平台" filterable :clearable="true" @clear="clean" @change="alew">
          <el-option
            v-for="item,index in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>

      <span style="margin-right:25px">渠道号</span>
      <!-- <el-select v-model="obj.channel_code" placeholder="请选择" filterable :clearable="false" @change="changeoption">
        <el-option
          v-for="item,index in platformSelectList"
          :key="index"
          :label="item.channel_code"
          :value="item.channel_code"
        />
      </el-select> -->
      <el-autocomplete
        v-model="obj.channel_code"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
        @input="iermw"
      />
    </div>

    <div class="allname">
      <span style="margin-right:11px">渠道名称</span>
      <el-input
        v-model="obj.channel_name"
        style="width:220px"
        placeholder="请输入内容"
        :disabled="true"
      />
    </div>
    <div class="allname">
      <span style="margin-right:25px">优化师</span>
      <el-input
        v-model="obj.optimizer"
        style="width:220px"
        placeholder="请输入内容"
        :disabled="true"
      />
    </div>
    <div class="item">
      <span class="item_title">日期</span>
      <el-date-picker
        v-model="timesr"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :clearable="false"
      />
    </div>
    <el-button type="primary" class="brwbtn" @click="addbtn">确 定</el-button>
  </div>
</template>

<script>
import { addOrder } from '@/api/report/wechatUsers.js'
import { getselectlist } from '@/api/providerAccountManagement/WeChatAccountFans'
export default {
  components: {},
  props: {
    platformselectlistarr: {}
  },
  data() {
    return {
      platformSelectList: [],
      obj: {
        platform_id: null,
        channel_code: '',
        channel_name: '',
        optimizer: '',
        reg_date_start: '',
        reg_date_end: ''
      },
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime() - (86400000 - (24 * 60 * 60 * 1000))
        }
      },
      timesr: []
    }
  },
  created() {
    this.platformSelectList = this.platformselectlistarr
    console.log(this.platformselectlistarr)
  },
  mounted() {

  },
  methods: {
    clean() {
      this.obj.platform_id = null
      this.obj.channel_code = ''
    },
    async addbtn() {
      if (this.obj.platform_id === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.obj.channel_code === '') {
        this.$message.error('请填写渠道号')
        return
      }
      if (this.obj.channel_name === '') {
        this.$message.error('请填写渠道名称')
        return
      }
      if (this.obj.optimizer === '') {
        this.$message.error('请填写优化师')
        return
      }
      console.log('this.timesr', this.timesr)
      if (this.timesr.length === 0) {
        this.$message.error('请选择时间')
        return
      }

      const data = await addOrder({
        platform_id: this.obj.platform_id,
        channel_code: this.obj.channel_code,
        channel_name: this.obj.channel_name,
        optimizer: this.obj.optimizer,
        reg_date_start: this.timesr.length ? this.timesr[0] : '',
        reg_date_end: this.timesr.length ? this.timesr[1] : ''
      })
      this.obj = {
        channel_code: '',
        channel_name: '',
        optimizer: '',
        reg_date_start: '',
        reg_date_end: ''
      }
      this.timesr = []
      this.$emit('handupdata')
      console.log('data', data)
    },
    changeoption(val) {
      console.log(val)
      const index = this.platformSelectList.findIndex((value, index) => value.channel_code === val)
      console.log('index', index)
      this.obj.channel_name = this.platformSelectList[index].channel_name
      this.obj.optimizer = this.platformSelectList[index].optimizer
    },
    querySearchAsync(queryString, callback) {
      var list = [{}]
      getselectlist({
        platform_id: this.obj.platform_id,
        keyword: this.obj.channel_code
      }).then(response => {
        for (const i of response.data) {
          i.value = i.channel_code// 想要展示的数据 // 将想要展示的数据作为value
        }
        list = response.data
        callback(list)
      })
    },
    handleSelect(item) {
      console.log(item)
      this.obj.channel_name = item.channel_name
      this.obj.optimizer = item.optimizer
    // do something
    },
    alew() {
      this.obj.channel_code = ''
      this.obj.channel_name = ''
      this.obj.optimizer = ''
    },
    iermw(val) {
      if (val === '') {
        this.obj.channel_name = ''
        this.obj.optimizer = ''
      }
      console.log('val', val)
    }
  }
}
</script>
<style scoped lang="less">
.brwbtn{
  margin-left: 370px;
  margin-top: 10px;
}
.allname{
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.item_title{
  margin-right: 40px;
}
.item{
  margin-top: 20px;
}
</style>
